import * as types from '../constants/actionTypes';
import api from '../../shared/api.json';

export function isLoaded(globalState) {
    return globalState.user && globalState.user.loaded;
}

export function fetchUser() {
    return {
        types: [types.LOAD, types.LOAD_SUCCESS, types.LOAD_FAIL],
        promise: (client) => client.get(api.user.fetch),
    };
}

export function fetchUserProfiles() {
    return {
        types: [
            types.FETCH_USER_PROFILES,
            types.FETCH_USER_PROFILES_SUCCESS,
            types.FETCH_USER_PROFILES_FAIL,
        ],
        promise: (client) => client.get(api.userProfiles.fetch),
    };
}
